import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Grid } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Button, CheckBox } from '@ds/react-components';

const styles = (theme) => ({
  root: {
    '& label': {
      [theme.breakpoints.down('sm')]: {
        marginRight: '0px',
      },
    },
  },
  label: {
    color: theme.palette.common.darkGray,
  },
  push: {
    float: 'right',
  },
  button: {
    padding: '10px 16px !important',
    '&:disabled': {
      borderColor: '#ebdddd',
    },
  },
});

const TermsAndConditionsControls = (props) => {
  const {
    classes,
    onClickDismiss,
    onClickAccept,
    tCCheckboxEnabled,
    acceptButtonEnabled,
    onChangeAcceptTermsAndConditions,
  } = props;

  return (
    <Grid container direction="row" justify="space-between">
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          disabled={!tCCheckboxEnabled}
          value="end"
          control={<CheckBox color="primary" />}
          label="I have read and understand the above terms and conditions"
          labelPlacement="end"
          onChange={onChangeAcceptTermsAndConditions}
          classes={{ root: classes.root, label: classes.label }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Grid
          container
          direction="row"
          justify="flex-end"
          alignItems="center"
          spacing={2}>
          <Grid item>
            <Button
              text="Decline"
              color="decline"
              onClick={onClickDismiss}
              classes={{ root: classes.button }}
            />
          </Grid>
          <Grid item>
            <Button
              text="Accept"
              color="success"
              onClick={onClickAccept}
              disabled={!acceptButtonEnabled}
              classes={{ root: classes.button }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

TermsAndConditionsControls.propTypes = {
  onClickDismiss: PropTypes.func,
  onClickAccept: PropTypes.func,
  onChangeAcceptTermsAndConditions: PropTypes.func,
  tCCheckboxEnabled: PropTypes.bool,
  acceptButtonEnabled: PropTypes.bool,
};
export default withStyles(styles)(TermsAndConditionsControls);
